<template>
  <div id="home">
    <keep-alive>
      <Descrizione />
    </keep-alive>
  </div>
  <div id="projects">
    <Work
      name="Web Developer"
      icon="globe"
      :works="web"
      :backgroundImage="require('../assets/web_design.jpg')"
      description="Sviluppo siti web con React, Angular, Vue, Html, Css, Scss, Node.js,
          Javascript, Typescript e Firebase"
    />

    <Work
      name="Application developer"
      icon="star"
      :works="app"
      :backgroundImage="require('../assets/Robot.jpg')"
      description="Programmo in C#, Java, Java EE, Python e Ionic per sviluppare
          applicazioni desktop e mobile"
    />

    <Work
      name="Videogames Developer"
      icon="bolt"
      :works="[]"
      :backgroundImage="require('../assets/videogames.jpg')"
      description="Per sviluppare videogiochi su qualsiasi piattaforma uso Unity 3d e
          programmo in C#"
    />
  </div>

  <div id="cv">
    <CV />
  </div>
</template>

<script>
import Descrizione from "../components/Descrizione.vue";
import CV from "../components/CV.vue";
import Work from "../components/Work.vue";
import { mapGetters } from "vuex";
export default {
  name: "Home",
  components: {
    Descrizione,
    Work,
    CV,
  },
  computed: {
    ...mapGetters({
      widthScreen: "getScreenWidth",
    }),
  },
  data() {
    return {
      web: [
        {
          img: require("../assets/CUVDA.jpg"),
          descrizione: `Sito per il consorzio turistico Valle d'Aosta sviluppato con Angular, PrimeNG, Firebase.`,
          link: "https://www.cuvda.it/",
          titolo: "CUVDA",
        },
        {
          img: require("../assets/reteTurismo.png"),
          descrizione: `Sito web per Rete turismo Valle d'Aosta realizzato con Vue, PrimeVue, Node js, Firebase.`,
          link: "https://reteturismovalledaosta.it/",
          titolo: "Rete Turismo",
        },
        {
          img: require("../assets/chinesecenter.jpeg"),
          descrizione: `Sito web sviluppato con Angular.`,
          link: "https://www.chinesecenter.it/",
          titolo: "Centro di Media e Cultura Cinese",
        },
        {
          img: require("../assets/italywonderland.png"),
          descrizione: `Sito per info su Navettatrekking.`,
          link: "https://www.navettatrekking.it/",
          titolo: "Italywonderland",
        },
      ],
      app: [
        {
          img: require("../assets/biblion.png"),
          descrizione: `Applicazione che permette di salvare,
           valutare, condividere e commentare film, serie tv e videogiochi. Sviluppato con Ionic, React, PrimeNG, Node js e  Firebase.`,
          link: "https://www.biblionweb.com/",
          titolo: "Biblion",
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss"></style>
